import { TableGroup, TableColumns } from 'Components/Common/Table/TableGroup';

import React, { useCallback, useMemo } from 'react';
import { formatCurrency } from 'Utils/Numbers';
import { COL_END_CLASS, COL_START_CLASS } from 'Constant';
import { useAppSelector } from 'App/Store';
import { ROLE_RECORD_MENU } from 'Constant/Roles';

const TableSaleMonth = ({
  dataSource,
  saleChannels,
}: {
  dataSource: any[];
  saleChannels: any[];
}): JSX.Element => {
  const { role } = useAppSelector((state) => state.auth);

  const isMiimEcOrExternalEc = useMemo(() => {
    if (
      role &&
      (role === ROLE_RECORD_MENU.ECCompMaster ||
        role === ROLE_RECORD_MENU.ECCompManager ||
        role === ROLE_RECORD_MENU.SALEChanelMaster ||
        role === ROLE_RECORD_MENU.SALEChanelManager)
    ) {
      return true;
    }
    return false;
  }, [role]);

  const renderChannelColumnTotal = useCallback(() => {
    return [
      {
        text: '',
        width: 80,
        bgColorCol: 'bg-dark',
        textColorCol: 'text-white',
        dataIndex: 'channelName',
        render: ({ item }: { item: any }) => {
          return <div className={`${COL_START_CLASS}`}>{item.channelName}</div>;
        },
      },
      {
        text: '販売数',
        width: 100,
        dataIndex: 'totalAmount',
        render: ({ item }: { item: any }) => {
          return <div className={`${COL_END_CLASS}`}>{formatCurrency(item.totalAmount || 0)}</div>;
        },
      },
      {
        text: '販売金額（税抜）',
        width: 100,
        dataIndex: 'totalMoney',
        render: ({ item }: { item: any }) => {
          return <div className={`${COL_END_CLASS}`}>{formatCurrency(item.totalMoney || 0)}</div>;
        },
      },
      {
        text: '販売金額（税込）',
        width: 100,
        dataIndex: 'totalAmount',
        render: ({ item }: { item: any }) => {
          return (
            <div className={`${COL_END_CLASS}`}>{formatCurrency(item.afterTaxTotalMoney || 0)}</div>
          );
        },
      },
    ];
  }, [saleChannels, isMiimEcOrExternalEc]);

  const mergedData = saleChannels
    .map((channel, index) => {
      const data = dataSource?.[0];
      return {
        channelName: channel.channelName,
        totalAmount: data?.[`totalAmount${index}`] || 0,
        totalMoney: data?.[`totalMoney${index}`] || 0,
        afterTaxTotalMoney: data?.[`afterTaxTotalMoney${index}`] || 0 || 0,
      };
    })
    .concat(
      isMiimEcOrExternalEc
        ? []
        : [
            {
              channelName: '合計',
              totalAmount: dataSource?.[0]?.totalAmount || 0,
              totalMoney: dataSource?.[0]?.totalMoney || 0,
              afterTaxTotalMoney: dataSource?.[0]?.afterTaxTotalMoney || 0,
            },
          ],
    );

  const columnTotals = useMemo(
    () =>
      [
        {
          columns: renderChannelColumnTotal(),
        },
      ] as TableColumns[],
    [renderChannelColumnTotal, saleChannels?.length],
  );

  return (
    <div className="d-flex flex-column" style={{ width: '100%' }}>
      <div className="me-3" style={{ width: '100%', marginTop: '21px' }}>
        <TableGroup dataSource={mergedData} tableColumns={columnTotals} />
      </div>
    </div>
  );
};
export default TableSaleMonth;
